
<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    v-bind="menuProps"
    min-width="auto"
  >
    <template v-slot:activator="{ on }">
      <v-chip v-on="!readonly ? on : null" slot="activator" :style="previewColor"></v-chip>
    </template>

    <v-card>
      <v-card-text>
        <v-row>
          <v-col v-if="!showPicker">
            <v-row style="width:120px;max-width:200px;">
              <v-col
                cols="3"
                style="padding: 0px;"
                v-for="(option, index) in options"
                :key="index"
                @click="selectPreset(index)"
                dense
              >
                <div style="margin:1px;">
                  <v-chip
                    small
                    :style="`background-color:${option.value};color:#FFFFFF;margin:0px;width:5px;height:25px;border-radius:50px;`"
                  ></v-chip>
                </div>
              </v-col>
              <v-list-item style="padding: 0px">
                <v-list-item-content>
                  <color-picker v-model="innerValue" :readonly="readonly" />
                </v-list-item-content>
              </v-list-item>
            </v-row>
          </v-col>
          <v-col v-else> </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="showPicker">
        <v-spacer></v-spacer>
        <v-btn text @click="menu = false">Cancel</v-btn>
        <v-btn color="info">Apply</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState } from "vuex";
import ColorPicker from "components/ColorPicker";
export default {
  components: {
    ColorPicker,
  },
  props: {
    value: [String, Object],
    hideDetails: Boolean,
    dense: Boolean,
    readonly: Boolean,
    menuProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
    inputProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      innerValue: this.value,
      menu: false,
      highlightDates: [],
      highlightClasses: {},
      showPicker: false,
    };
  },

  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },

  methods: {
    emitBlur() {
      this.$emit("blur");
    },
    onChange() {
      this.$emit("onChange");
    },
    selectPreset(value) {
      this.innerValue = this.options[value].value;
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),

    previewColor() {
      return (
        "margin-top:20px;margin-left:5px;border-radius:5px;width:40px;height:30px;background-color:" +
        this.innerValue
      );
    },
    resetProps() {
      return { ...this.$attrs };
    },
    inputValue() {
      return "";
    },
    options() {
      return [
        { value: "#ad1457", text: "ad1457" },
        { value: "#f4511e", text: "f4511e" },
        { value: "#e4c442", text: "e4c442" },
        { value: "#0a8042", text: "0a8042" },
        { value: "#3e51b5", text: "3e51b5" },
        { value: "#8e24aa", text: "8e24aa" },
        { value: "#d81a60", text: "d81a60" },
        { value: "#ef6c00", text: "ef6c00" },
        { value: "#c0ca33", text: "c0ca33" },
        { value: "#009688", text: "009688" },
        { value: "#7986cb", text: "7986cb" },
        { value: "#795548", text: "795548" },
        { value: "#d50000", text: "d50000" },
        { value: "#f09300", text: "f09300" },
        { value: "#7cb343", text: "7cb343" },
        { value: "#039be5", text: "039be5" },
        { value: "#b39ddb", text: "b39ddb" },
        { value: "#616161", text: "616161" },
        { value: "#e67c73", text: "e67c73" },
        { value: "#f6bf26", text: "f6bf26" },
        { value: "#33b679", text: "33b679" },
        { value: "#4285f4", text: "4285f4" },
        { value: "#9e69af", text: "9e69af" },
        { value: "#a79b8e", text: "a79b8e" },

        // {
        //   value: "#fc1100",
        //   text: `Red`,
        // },
        // {
        //   value: "#fcb500",
        //   text: `Orange`,
        // },
        // {
        //   value: "#ffff00",
        //   text: `Yellow`,
        // },
        // {
        //   value: "#0400ff",
        //   text: `Blue`,
        // },
        // {
        //   value: "#8c00ff",
        //   text: `Purple`,
        // },
        // {
        //   value: "#008033",
        //   text: `Green`,
        // },
      ];
    },
  },
};
</script>